import { defineEntity, custom } from './_helpers.js';

export default defineEntity('unit', {
    'membership.changed': custom({ scope: 'state' }),
    'member.added':       custom({ scope: 'state' }),
    'member.removed':     custom({ scope: 'state' }),
});
